import React from "react";

function ScopeDefinitionIcon({ height = "80", width = "80", className = "" }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 6.66667C8.15833 6.66667 6.66667 8.15833 6.66667 10C6.66667 11.8417 8.15833 13.3333 10 13.3333C11.8417 13.3333 13.3333 11.8417 13.3333 10C13.3333 8.15833 11.8417 6.66667 10 6.66667ZM4.16667 12.5H2.5V15.8333C2.5 16.75 3.25 17.5 4.16667 17.5H7.5V15.8333H4.16667V12.5ZM4.16667 4.16667H7.5V2.5H4.16667C3.25 2.5 2.5 3.25 2.5 4.16667V7.5H4.16667V4.16667ZM15.8333 2.5H12.5V4.16667H15.8333V7.5H17.5V4.16667C17.5 3.25 16.75 2.5 15.8333 2.5ZM15.8333 15.8333H12.5V17.5H15.8333C16.75 17.5 17.5 16.75 17.5 15.8333V12.5H15.8333V15.8333Z"
        fill="#000"
        className={className}
      />
    </svg>
  );
}

export default ScopeDefinitionIcon;
